

import React, { useState, useEffect } from "react";
import {
  Box,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Drawer,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
import {
  Dashboard as DashboardIcon,
  Settings as SettingsIcon,
  Payment as PaymentIcon,
  LocalOffer as LocalOfferIcon,
  People as PeopleIcon,
  Person as PersonIcon,
  Assessment as AssessmentIcon,
  RestaurantMenu as RestaurantMenuIcon,
} from "@mui/icons-material";

const allMenuItems = [
  // { key: "Home", text: "Home", icon: <DashboardIcon />, route: "/homes" },
  { key: "Subscription", text: "Subscription", icon: <AssessmentIcon />, route: "/Foodsubscription" },
  { key: "Client_Management", text: "Client Management", icon: <PeopleIcon />, route: "/foodclient" },
  { key: "Inventory_Management", text: "Control Management", icon: <PeopleIcon />, route: "/controllmanagmentsuper" },
  { key: "Order_Management", text: "Order Management", icon: <AssessmentIcon />, route: "/foodorder" },
  // { key: "Menu_Management", text: "Menu Management", icon: <RestaurantMenuIcon />, route: "/cateringmenu" },
  { key: "User_Management", text: "User Management", icon: <PersonIcon />, route: "/userdetails" },
  { key: "Settings_Controls", text: "Setting & Control", icon: <SettingsIcon />, route: "/foodsetingspage" },
  { key: "Account_History", text: "Account & History", icon: <PaymentIcon />, route: "/foodaccounts" },
  { key: "Promotions_Discounts", text: "Promotions Discounts", icon: <LocalOfferIcon />, route: "/foodpramotions" },
  { key: "Care_Management", text: "Care Management", icon: <PeopleIcon />, route: "/foodcare" },
  // { key: "Terms_Conditions", text: "Terms & Conditions", icon: <DashboardIcon />, route: "/foodterms" },
  { key: "Report_Analysis", text: "Report & Analysis", icon: <DashboardIcon />, route: "/foodreports" },
];

const Sidebar = () => {
  const [open, setOpen] = useState(false);
  const [allowedModules, setAllowedModules] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();

  const isPersistentVariantScreen = useMediaQuery("(max-width:1024px)");
  const isNarrowerWidthScreen = useMediaQuery("(max-width:1250px)");
  const drawerVariant = isPersistentVariantScreen ? "persistent" : "permanent";
  const drawerWidth = isNarrowerWidthScreen ? 180 : 215;

  useEffect(() => {
    const employeeId = localStorage.getItem("employeeId");
    const storedModulesRaw = localStorage.getItem("businessModules");

    // Convert safely to array
    let storedModules = [];
    try {
      storedModules = storedModulesRaw ? JSON.parse(storedModulesRaw) : [];
    } catch (e) {
      console.error("❌ Failed to parse modules:", e);
    }

    console.log("👤 Employee ID:", employeeId);
    console.log("📦 Modules from login response:", storedModules);

    let modulesToShow = [];

    // ✅ Case 1: If no employeeId or id is 0/null, show all modules
    if (!employeeId || employeeId === "0" || employeeId === null || employeeId === "null") {
      modulesToShow = allMenuItems;
      console.log("🟡 Showing all modules because employeeId is null/0");
    } else {
      // ✅ Case 2: Show only those in storedModules
      const moduleKeysLower = storedModules.map((m) => m.toLowerCase());
      modulesToShow = allMenuItems.filter((item) =>
        moduleKeysLower.includes(item.key.toLowerCase())
      );
    }

    setAllowedModules(modulesToShow);
    console.log("📝 Final Allowed Modules:", modulesToShow.map((m) => m.key));
  }, []);

  return (
    <>
      <Box
        sx={{
          position: "fixed",
          top: { xs: 52, md: 75 },
          left: { xs: 12, md: 75 },
          transition: "left 0.3s ease-in-out",
          zIndex: 1301,
        }}
      >
        <IconButton
          onClick={() => setOpen(!open)}
          sx={{
            color: "#B276C3",
            display: { xs: "flex", sm: "flex", md: "none" }, // 👈 hide on md+
          }}
        >
          <MenuIcon fontSize="large" />
        </IconButton>

      </Box>

      <Drawer
        anchor="left"
        variant={drawerVariant}
        open={open}
        onClose={isPersistentVariantScreen ? () => setOpen(false) : undefined}
        PaperProps={{
          sx: {
            width: drawerWidth,
            marginTop: "91px",
            overflowY: "auto",
            height: "calc(100vh - 80px)",
            borderRight: 0,
            backgroundColor: "#fff",
            transition: theme.transitions.create("width", {
              easing: theme.transitions.easing.sharp,
              duration: theme.transitions.duration.enteringScreen,
            }),
            zIndex: 1300,
          },
        }}
      >
        <Box
          sx={{
            width: "100%",
            height: "100%",
            overflowY: "auto",
            padding: "0px 5px",
            marginTop: "10px",
            "&::-webkit-scrollbar": { display: "none" },
            scrollbarWidth: "none",
          }}
        >
          <List>
            {allowedModules.map((item) => (
              <ListItem key={item.key} disablePadding>
                <ListItemButton
                  sx={{
                    background:
                      location.pathname === item.route ? "#A055B0" : "#B276C3",
                    borderRadius: "20px",
                    marginBottom: "10px",
                    color: "#fff",
                    "&:hover": { background: "#A055B0" },
                    paddingY: "10px",
                  }}
                  onClick={() => {
                    navigate(item.route);
                    if (isPersistentVariantScreen) setOpen(false);
                  }}
                >
                  <ListItemIcon sx={{ color: "#fff", minWidth: "27px" }}>
                    {item.icon}
                  </ListItemIcon>
                  <ListItemText
                    primary={item.text}
                    primaryTypographyProps={{
                      style: { fontSize: "12px", fontWeight: "bold" },
                    }}
                  />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        </Box>
      </Drawer>
    </>
  );
};

export default Sidebar;



